import React from 'react';
import {
	LDContext,
	useLDClient,
} from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { UserProfileDetailsSelector } from '@store/selectors/UserProfileSelector';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';

export const LaunchDarklyAppWrapper: React.FC = ({ children }) => {
	const user = useSelector(UserProfileDetailsSelector);
	const { userId, firstName, lastName, email: initialEmail, username, userRoles } = user;
	const ldClient = useLDClient();
	const ministry = username?.split('\\')[0];

	React.useEffect(() => {
		const ldContext: LDContext = {
			kind: 'multi',
			user: {
				key: `ssmUi:${userId}`,
				name: `${firstName} ${lastName}`,
				email: initialEmail,
				roles: userRoles,
			},
			org: {
				key: `ministry:${ministry}`,
				ministry,
			}
		};

		/***
		 REMOVE THIS SECTION WHEN TESTING IS NO LONGER NEEDED (REMOVE_TEST)
		 ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄ ⌄
		 START
		***/
		const searchParams = new URLSearchParams(location.search);
		const testKey = searchParams.get('testKey');
		// Conditionally add test context only on TestErrorPage when testKey is present in query params
		if (location.pathname === ROUTE_CONSTANTS.TEST_ERROR_PAGE && testKey) {
			if (testKey) {
				ldContext.test = {
					key: testKey,
				};
			}
		}
		/***
		 END
		 ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃ ⌃
		 ***/

		if (ldClient && userId) {
			void ldClient.identify(ldContext)
		}
	}, [firstName, initialEmail, lastName, ldClient, ministry, userId, userRoles]);

	return <div className="App">{children}</div>;
};
